<template>
    <ProjectDescriptionText :jsonData="developmentData" :basePath="'/development'" />
</template>

<script>
    import ProjectDescriptionText from "../components/ProjectDescriptionText.vue"
    import developmentData from '@/assets/data/development.json';

    export default {
        name: 'Development',
        components: {
            ProjectDescriptionText
        },
        data() {
            return {
                developmentData
            }
        }
    }
</script>